@if (isLoading()) {
    <div class="c-sona-button__loading-indicator">
        <sona-spinner size="xxs"></sona-spinner>
    </div>
} @else {
    <ng-content select="[sonaButtonPrefix]"></ng-content>
}

<div class="c-sona-button__label">
    <ng-content></ng-content>
</div>

<ng-content select="[sonaButtonSuffix]"></ng-content>
